import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Form  from '../../Form/Form';

interface LogoutProps {
  close: () => void
}

function Logout({ close }: LogoutProps) {
  const { t } = useTranslation('common');

  const closeFunction = (e: KeyboardEvent) => {
    if (e.key === 'Enter') close();
  };

  useEffect(() => {
    document.addEventListener('keydown', closeFunction);

    return () => {
      document.removeEventListener('keydown', closeFunction);
    };
  });

  const steps = [
    {
      buttons: [
        {
          type: 'submit',
          label: t('form.ok')
        }
      ]
    }
  ];

  return (
    <Form
      containerClass="logout-form"
      steps={ steps }
      close={ close }
    />
  );
}

export default Logout;
